const TOKEN_KEY = "cosmicpar.owner.v1";
const HANDLE_KEY = "cosmicpar.handle.v1";

export function getStoredToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function getStoredHandle(): string | null {
  try {
    return localStorage.getItem(HANDLE_KEY);
  } catch {
    return null;
  }
}

export function persistIdentity(handle: string, token: string): void {
  try {
    localStorage.setItem(HANDLE_KEY, handle);
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    /* storage disabled */
  }
}

export function clearIdentity(): void {
  try {
    localStorage.removeItem(HANDLE_KEY);
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* noop */
  }
}

export function generateOwnerToken(): string {
  if (typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

export async function hashToken(token: string): Promise<string> {
  const data = new TextEncoder().encode(token);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(digest), (b) =>
    b.toString(16).padStart(2, "0"),
  ).join("");
}
